'use client';
import Script from 'next/script';
import { useEffect } from 'react';
import { useAppStore } from '@/features/shared/app-store';

/**
 * OneTrust cookie consent scripts:
 * - `OtAutoBlock.js` and `otSDKStub.js` must load with `beforeInteractive`
 *   so cookies/scripts are blocked before hydration.
 * - We define `window.OptanonWrapper` inside `useEffect` to get callbacks
 *   when OneTrust initializes or consent changes.
 * - `initConsent()` runs once on mount to sync initial state,
 *   and `refresh()` is called whenever OneTrust invokes the wrapper.
 */
export default function OneTrustScripts() {
  const initConsent = useAppStore((state) => state.consentActions.init);
  const refresh = useAppStore((state) => state.consentActions.refresh);
  useEffect(() => {
    if (typeof window === 'undefined') return;
    window.OptanonWrapper = () => {
      refresh();
    };
    void initConsent();
  }, [initConsent, refresh]);

  return (
    <>
      {/* otSDKStub.js: OneTrust main SDK to render the cookie banner and manage consent */}
      {/* eslint-disable-next-line @next/next/no-before-interactive-script-outside-document */}
      <Script
        src='https://cdn.cookielaw.org/scripttemplates/otSDKStub.js'
        data-domain-script={process.env.NEXT_PUBLIC_CONSENT_WEBSITE_ID}
        type='text/javascript'
        strategy='beforeInteractive'
      />
    </>
  );
}
